import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import ServiceRequestForm from './ServiceRequestForm';
import { serviceAnfrageByServiceUrlSelector } from '../../../modules/selectors/standort/dienstleistungen';
import loadable from '@loadable/component';
import { hideServiceFormSelector } from '../../../modules/selectors/standort/theme';

const NotFound = loadable(() => import('../ErrorPages/NotFound/NotFound'));

function ServiceRequest() {
    const { serviceUrl } = useParams();
    const service = useSelector(state => serviceAnfrageByServiceUrlSelector(state, { serviceUrl }));
    const hideServiceForm = useSelector(hideServiceFormSelector);

    if ((!service && serviceUrl) || hideServiceForm) {
        return <NotFound />;
    }

    return (
        <>
            <section className="uk-section uk-section-primary">
                <div className="uk-container uk-container-xsmall">
                    <div className="uk-h1 uk-text-bold uk-text-center">Ihre Service Anfrage</div>
                    <div className="info-text-box">
                        <div className="uk-text-left0m info-text uk-visible@m">
                            <p>
                                Für den gewählten Service können wir Ihnen kein Festpreisangebot anzeigen, da die Kosten von Material,
                                Modell und Baureihe des Fahrzeugs abhängig sind und variieren können.
                            </p>
                            <p>
                                Bitte verwenden Sie das folgende Formular und teilen uns Ihr Anliegen mit. Unser Werkstattmeister wird sich
                                anschließend bei Ihnen mit einem individuellen und unverbindlichen Angebot melden.
                            </p>
                        </div>
                        <div className="uk-text-left0m info-text uk-hidden@m">
                            <p>
                                Liebe Kundinnen, liebe Kunden, für den gewählten Service können wir Ihnen leider kein Festpreisangebot
                                anzeigen. Unsere Meisterwerkstatt erstellt Ihnen gerne ein individuelles und unverbindliches Angebot. Bitte
                                nutzen Sie folgendes Formular dafür.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="uk-section uk-section-default">
                <div className="uk-container uk-container-xsmall">
                    <ServiceRequestForm />
                </div>
            </section>
        </>
    );
}

export default ServiceRequest;
